import { t } from 'i18next';

import { TabsType } from './types';

interface GetTabsParams {
  options: {
    isStock: boolean;
    isDocumentsTabVisible: boolean;
    isChartTabVisible?: boolean;
  };
  isNewEarningsTabEnabled: boolean;
}

export const getTabs = ({
  options,
  isNewEarningsTabEnabled,
}: GetTabsParams) => {
  return [
    {
      tabKey: TabsType.Overview,
      tabLabel: t('widget:assetOverview.overview'),
    },
    ...(isNewEarningsTabEnabled
      ? [
          {
            tabKey: TabsType.Earnings,
            tabLabel: t('widget:assetOverview.earnings'),
            isHidden: !options.isStock,
          },
        ]
      : []),
    {
      tabKey: TabsType.Financials,
      tabLabel: t('asset-overview:financials'),
      isHidden: !options.isStock,
    },
    {
      tabKey: TabsType.Chart,
      tabLabel: t('widget:assetOverview.chart'),
      isHidden: options.isChartTabVisible === false,
    },
    {
      tabKey: TabsType.Connections,
      tabLabel: t('widget:assetOverview.knowledgeGraph.name'),
      isHidden: !options.isStock,
    },
    {
      tabKey: TabsType.NewsInsights,
      tabLabel: t('widget:assetOverview.news'),
      isHidden: !options.isStock,
    },
    {
      tabKey: TabsType.Documents,
      tabLabel: t('widget:assetOverview.documents'),
      isHidden: !options.isDocumentsTabVisible,
    },
    ...(!isNewEarningsTabEnabled
      ? [
          {
            tabKey: TabsType.Earnings,
            tabLabel: t('widget:assetOverview.earnings'),
            isHidden: !options.isStock,
          },
        ]
      : []),
  ];
};
